(function () {
  var FORM_ID = "_rsi-cod-form-modal-form";
  var ENDPOINT = "https://api-new.3alla9ni.net/webhook/shopify/quick-form-abandoned";

  var hasSubmitted = false;
  var sentKeys = {};
  var LS_PREFIX = "__RSI_ABANDON_SENT__";

  function safeLSGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeLSSet(key, val) {
    try { window.localStorage.setItem(key, val); } catch (e) {}
  }

  function getShopifyDomain() {
    try {
      if (window.Shopify && typeof window.Shopify.shop === "string" && window.Shopify.shop.trim() !== "") {
        return window.Shopify.shop.trim();
      }
    } catch (e) {}
    return null;
  }

  function getFormEl() {
    return document.getElementById(FORM_ID);
  }

  function formToObject(formEl) {
    var fd = new FormData(formEl);
    var obj = {};
    fd.forEach(function (v, k) {
      if (obj[k] !== undefined) {
        if (!Array.isArray(obj[k])) obj[k] = [obj[k]];
        obj[k].push(v);
      } else {
        obj[k] = v;
      }
    });
    return obj;
  }

  function shouldSend(formObj) {
    var phone = (formObj.phone || formObj.telephone || "").toString().trim();
    return !!phone;
  }

  function normalizePhone(raw) {
    return (raw || "").toString().replace(/[^\d+]/g, "").trim();
  }

  function isPhoneComplete(raw) {
    var p = normalizePhone(raw);
    var digits = p.replace(/[^\d]/g, "");
    if (/^\+216\d{8}$/.test(p)) return true;
    if (/^\d{8}$/.test(digits)) return true;
    return false;
  }

  function getPhoneFromData(data) {
    return (data && (data.phone || data.telephone || data.tel || data.mobile || "")) || "";
  }

  // Récupère les produits depuis le DOM du modal RSI (querySelectorAll natif)
  function extractProductsFromModal() {
    var formEl = getFormEl();
    if (!formEl) return [];

    var items = [];
    var lineItems = formEl.querySelectorAll("._rsi-modal-line-item");

    lineItems.forEach(function (el) {
      var variantId = el.getAttribute("data-line-item-variant-id") || null;

      var titleEl = el.querySelector("a._rsi-modal-line-item-title");
      var title = titleEl ? (titleEl.textContent || "").trim() || null : null;

      var qEl = el.querySelector("._rsi-modal-line-item-quantity");
      var qText = qEl ? (qEl.textContent || "").trim() : "";
      var quantity = parseInt(qText, 10);
      if (!quantity || quantity < 1) quantity = 1;

      var priceEl = el.querySelector("._rsi-modal-line-item-final-price");
      var price = priceEl ? (priceEl.textContent || "").trim() || null : null;

      var imgEl = el.querySelector("img._rsi-modal-line-item-image");
      var img = imgEl ? (imgEl.getAttribute("src") || null) : null;

      items.push({
        variant_id: variantId,
        product_id: null,
        title: title,
        quantity: quantity,
        price: price,
        compare_at_price: null,
        image: img
      });
    });

    // Fallback hidden inputs si la section order summary est "not active"
    if (!items.length) {
      var data = formToObject(formEl);
      items = extractProductsFromHiddenInputs(data);
    }

    return items;
  }

  function extractProductsFromHiddenInputs(data) {
    var variants = {};
    var qtys = {};
    Object.keys(data || {}).forEach(function (k) {
      if (typeof k !== "string") return;

      if (k.indexOf("item_variant_id[") === 0) {
        var inner = k.substring("item_variant_id[".length, k.length - 1);
        variants[inner] = data[k];
      }
      if (k.indexOf("item_quantity[") === 0) {
        var inner2 = k.substring("item_quantity[".length, k.length - 1);
        qtys[inner2] = data[k];
      }
    });

    var out = [];
    Object.keys(variants).forEach(function (innerKey) {
      var variantId = variants[innerKey];
      var q = parseInt(qtys[innerKey] || "1", 10);
      if (!q || q < 1) q = 1;

      out.push({
        variant_id: variantId ? String(variantId) : null,
        product_id: null,
        title: null,
        quantity: q,
        price: null,
        compare_at_price: null,
        image: null
      });
    });

    return out;
  }

  function buildPayload(formEl, reason) {
    var data = formToObject(formEl);

    return {
      shopify_domain: getShopifyDomain(),
      event: "form_abandoned",
      reason: reason || "phone_filled",
      occurred_at: new Date().toISOString(),
      page_url: window.location.href,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      form_id: FORM_ID,
      abandoned_order_id: data.abandoned_order_id || null,
      country_code: data.country_code || null,
      cart_token: data.cart_token || null,
      data: data,
      products: extractProductsFromModal()
    };
  }

  function buildDedupKey(payload) {
    var shop = payload.shopify_domain || "unknown_shop";
    var cart = payload.cart_token || payload.abandoned_order_id || "no_cart";
    var phone = normalizePhone(getPhoneFromData(payload.data));
    return [LS_PREFIX, shop, cart, phone].join("|");
  }

  function sendAbandon(payload) {
    var dkey = buildDedupKey(payload);

    if (sentKeys[dkey]) return;
    if (safeLSGet(dkey) === "1") {
      sentKeys[dkey] = true;
      return;
    }

    sentKeys[dkey] = true;
    safeLSSet(dkey, "1");

    var body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        navigator.sendBeacon(ENDPOINT, blob);
        return;
      } catch (e) {}
    }

    try {
      fetch(ENDPOINT, {
        method: "POST",
        mode: "no-cors",
        keepalive: true,
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: body
      }).catch(function () {});
    } catch (e) {}
  }

  function trySend(reason) {
    var formEl = getFormEl();
    if (!formEl) return;
    if (hasSubmitted) return;

    var payload = buildPayload(formEl, reason);

    var phone = getPhoneFromData(payload.data);
    if (!isPhoneComplete(phone)) return;
    if (!shouldSend(payload.data)) return;

    sendAbandon(payload);
  }

  // ====== Event delegation (sans jQuery) ======
  var PHONE_INPUT_NAMES = ["phone", "telephone", "tel", "mobile"];

  function isPhoneInputInsideForm(target) {
    if (!target || target.nodeType !== 1) return false;
    if (target.tagName !== "INPUT") return false;
    if (!target.closest || !target.closest("#" + FORM_ID)) return false;
    var name = target.getAttribute("name") || "";
    var type = (target.getAttribute("type") || "").toLowerCase();
    if (PHONE_INPUT_NAMES.indexOf(name) !== -1) return true;
    if (type === "tel") return true;
    return false;
  }

  var __phoneDebounceT = null;

  function onPhoneEvent(e) {
    if (!isPhoneInputInsideForm(e.target)) return;
    if (__phoneDebounceT) clearTimeout(__phoneDebounceT);
    __phoneDebounceT = setTimeout(function () {
      trySend("phone_filled");
    }, 400);
  }

  function hookPhoneWatcher() {
    // input et change bulle normalement
    document.addEventListener("input", onPhoneEvent, true);
    document.addEventListener("change", onPhoneEvent, true);
    // blur ne bulle pas -> on utilise focusout (equivalent qui bulle)
    document.addEventListener("focusout", onPhoneEvent, true);
  }

  function hookSubmitWatcher() {
    document.addEventListener("submit", function (e) {
      var t = e.target;
      if (t && t.id === FORM_ID) {
        hasSubmitted = true;
      }
    }, true);
  }

  function init() {
    hookSubmitWatcher();
    hookPhoneWatcher();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // ---------------------------
  // Méthodes de test console
  // ---------------------------
  window.__RSI_RESET_SESSION_SENT = function () {
    sentKeys = {};
    console.log("[RSI] sentKeys reset (session/page only)");
  };

  window.__RSI_SIMULATE_PHONE_FILLED = function () {
    trySend("test_simulate_phone_filled");
  };

  window.__RSI_CLEAR_DEDUP = function () {
    try {
      var keys = [];
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf(LS_PREFIX) === 0) keys.push(k);
      }
      keys.forEach(function (k) { localStorage.removeItem(k); });
      console.log("[RSI] cleared dedup keys:", keys.length);
    } catch (e) {
      console.log("[RSI] failed to clear dedup keys");
    }
  };
})();
